import { MdRemoveRedEye } from "react-icons/md";
import { TableBottomSection } from "./TableBottomSection";
import { useEffect, useState } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { NoDataContent } from "../EmptyDataComponent/NoDataContent";

const TABLE_HEAD = ["Image", "Name", "Email", "Phone Number", "Status", ""];

export const DisplayUserList = () => {
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const [userList, setUserList] = useState(null);
  const [filter, setFilter] = useState("all");
  const [unfilteredData, setUnfilteredData] = useState({
    users: [],
    pagination: {},
  });
  const [constraints, setConstraints] = useState({
    page: 1,
    limit: 5,
  });

  const navigate = useNavigate();

  const handleVerify = async (id, verifyStatus) => {
    try {
      const accessToken = JSON.parse(window.localStorage.getItem("token")).token;
      const response = await fetch(`${BASE_URL}/api/users/admin-verify/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          verify: verifyStatus,
        }),
      });
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      if (!response) {
        throw new Error("Network failure");
      }

      const data = await response.json();
      const temp = unfilteredData.users.map((element) => {
        if (element.email === data.user.email) {
          return data.user;
        }
        return element;
      });
      setUnfilteredData((prev) => ({
        pagination: prev.pagination,
        users: temp,
      }));
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchUserList = async () => {
    try {
      const accessToken = JSON.parse(window.localStorage.getItem("token")).token;
      let url = `${BASE_URL}/api/users/college-verified-list?page=${constraints.page}&limit=${constraints.limit}`;

      // Add verified parameter to the URL based on the filter
      if (filter === "verified") {
        url += `&verified=true`;
      } else if (filter === "notVerified") {
        url += `&verified=false`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      const data = await response.json();
      setUserList(data);
      setUnfilteredData(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, [constraints, filter]);

  useEffect(() => {
    if (!unfilteredData || unfilteredData.users.length <= 0) {
      return;
    }

    let data = {};
    data.pagination = unfilteredData.pagination;
    data.users = unfilteredData.users.filter((element) => {
      if (filter === "verified") {
        return element.adminVerified;
      } else if (filter === "notVerified") {
        return !element.adminVerified;
      } else {
        return true;
      }
    });
    setUserList(data);
  }, [filter, unfilteredData]);

  return (
    <section>
      <div className="bg-gray-50 sticky top-0 w-full py-4 flex justify-between items-center">
        <span className="ml-4 text-lg opacity-60 font-semibold">
          Student Verification List
        </span>
        <div className="flex gap-2">
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200 ${
              filter === "all"
                ? "bg-zinc-600 text-white border-zinc-600"
                : "bg-white text-black border-zinc-600"
            }`}
            onClick={() => {
              setFilter("all");
              setConstraints((prev) => ({ ...prev, page: 1 }));
            }}
          >
            All
          </button>
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200 ${
              filter === "verified"
                ? "bg-green-600 text-white border-green-600"
                : "bg-white text-black border-green-600"
            }`}
            onClick={() => {
              setFilter("verified");
              setConstraints((prev) => ({ ...prev, page: 1 }));
            }}
          >
            Verified
          </button>
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200 ${
              filter === "notVerified"
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-black border-red-600"
            }`}
            onClick={() => {
              setFilter("notVerified");
              setConstraints((prev) => ({ ...prev, page: 1 }));
            }}
          >
            Not Verified
          </button>
        </div>
      </div>
      {userList?.users?.length > 0 ? (
        <table className="w-full text-left rounded overflow-hidden">
          <thead className="border-b-2 border-black border-opacity-20">
            <tr>
              {TABLE_HEAD.map((eachHead) => (
                <th key={eachHead} className="border-b border-blue-gray-50 p-4">
                  {eachHead}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {userList.users.map((eachRow) => (
              <tr key={eachRow.id}>
                <td className="p-4 border-b border-blue-50">
                  {eachRow.image ? (
                    <img
                      src={`${process.env.REACT_APP_SERVER_BASE_URL}/${eachRow.image}`.replace(/\\/g, "/")}
                      className="w-8 aspect-square rounded-full object-cover"
                    />
                  ) : (
                    <FaRegUserCircle size={28} />
                  )}
                </td>
                <td className="p-4 border-b border-blue-50">{eachRow.username}</td>
                <td className="p-4 border-b border-blue-50">
                  <span>{eachRow.email}</span>
                </td>
                <td className="p-4 border-b border-blue-50">
                  <span>{eachRow.phoneNumber}</span>
                </td>
                <td className="p-4 border-b border-blue-50">
                  <button
                    onClick={() => handleVerify(eachRow.userId, !eachRow.adminVerified)}
                    className={`p-2 text-xs flex justify-center items-center ${
                      eachRow.adminVerified
                        ? "bg-green-600 text-green-600"
                        : "bg-red-600 text-red-600"
                    } bg-opacity-40 hover:bg-opacity-50 duration-200 font-bold rounded`}
                  >
                    {eachRow.adminVerified ? "Verified" : "Not Verified"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoDataContent message="No students found for further verification. Check back later" />
      )}
      {userList?.users?.length > 0 && (
        <TableBottomSection
          updateConstraint={setConstraints}
          constraints={constraints}
          currentPage={userList.pagination.currentPage}
          totalPages={userList.pagination.totalPages}
        />
      )}
    </section>
  );
};
